import { render } from "./IndividualInfoSchoolchild.vue?vue&type=template&id=43b99591&scoped=true"
import script from "./IndividualInfoSchoolchild.vue?vue&type=script&lang=js"
export * from "./IndividualInfoSchoolchild.vue?vue&type=script&lang=js"

import "./IndividualInfoSchoolchild.vue?vue&type=style&index=0&id=43b99591&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b99591"]])

export default __exports__